import Color from "color";
import { useSwatch } from "../hooks/makeswift-api";
function useColorValue(data, definition) {
  const swatchId = data?.swatchId ?? null;
  const swatch = useSwatch(swatchId);
  const alpha = data?.alpha ?? 1;
  if (swatch == null) {
    const { defaultValue } = definition.config;
    if (defaultValue === void 0)
      return void 0;
    let defaultColor;
    try {
      defaultColor = Color(definition.config.defaultValue);
    } catch {
      defaultColor = Color();
    }
    return defaultColor.rgb().string();
  }
  return Color({ h: swatch.hue, s: swatch.saturation, l: swatch.lightness }).alpha(alpha).rgb().string();
}
export {
  useColorValue
};
//# sourceMappingURL=color.js.map